// Workspace auth domain service — mirrors apps/api/modules/auth/router.py.
// Errors are mapped here (not in a hook) because contexts/SessionContext
// consumes these directly: {status, message} with 401 = wrong code / dead
// session, 429 = throttled, 0 = unreachable.
//
// Both calls carry a TIMEOUT (2026-10-01): a request that never answers
// used to leave the wall checking for ever. Past it the call fails as
// unreachable (status 0) — the wall says so, a stored session is kept.
// Long enough for a cold API instance to start.
import axios from "axios";
import { API } from "services/CONSTANTS";
import { toApiError } from "services/errorHandler";

export const AUTH_TIMEOUT_MS = 20000;

export async function login(code, deviceId) {
  try {
    const { data } = await axios.post(
      API.authLogin(),
      { code, device_id: deviceId || undefined },
      { timeout: AUTH_TIMEOUT_MS },
    );
    return data; // {slug, name, industry_code}
  } catch (err) {
    throw toApiError(err);
  }
}

export async function verify(slug, code) {
  try {
    const { data } = await axios.post(
      API.authVerify(),
      { slug, code },
      { timeout: AUTH_TIMEOUT_MS },
    );
    return data;
  } catch (err) {
    throw toApiError(err);
  }
}
